<template>
  <div class="left">
    <el-timeline>
      <el-timeline-item timestamp="报名动态" placement="top">
        <RouterLink target="_blank" to="/guide/guideitem">
          <el-button>报名条件</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/news/policy">
          <el-button>官网政策</el-button>
        </RouterLink>
      </el-timeline-item>
      <el-timeline-item timestamp="大纲/教材" placement="top">
        <RouterLink target="_blank" to="/examline/lineitem">
          <el-button>考试大纲</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/books">
          <el-button>图书讲义</el-button>
        </RouterLink>
      </el-timeline-item>
      <el-timeline-item timestamp="备考安排" placement="top">
        <RouterLink target="_blank" to="/advice/adviceitem">
          <el-button>备考建议</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/read">
          <el-button>免费资料</el-button>
        </RouterLink>
      </el-timeline-item>
      <el-timeline-item timestamp="课题体验" placement="top">
        <RouterLink target="_blank" to="/video">
          <el-button>课程体验</el-button>
        </RouterLink>

        <el-button
          ><a
            target="_blank"
            href="http://mpt.ksbao.com/mryl?agentCode=055618&cardid=1018"
            >每日一练</a
          ></el-button
        >
      </el-timeline-item>
    </el-timeline>
  </div>
  <div class="test-bottom">
    <el-button
      ><el-icon><Document /></el-icon>每日一练(手机版)</el-button
    >
  </div>
  <img
    style="width: 100px; height: 100px; text-align: center; margin: 10px auto"
    src="../../../../../public/imgs/考试宝典-每日一练.jpeg"
    alt=""
  />
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="less">
.el-timeline-item__content {
  display: flex;
  justify-content: space-around;
}
.test-bottom {
  display: flex;
  justify-content: center;
}
</style>
